import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-map-gl/maplibre';
import bbox from '@turf/bbox';

import { ForwardButton } from '../components/Button/ForwardButton';
import { SecondaryButtonWithIcon } from '../components/Button/SecondaryButtonWithIcon';
import { useGeoLocation } from '../hooks/useGeoLocation';
import { setZonesOfCity } from '../slices/mapSlice';
import { useModal } from '../hooks/useModal';
import { useTranslation } from 'react-i18next';


export const NeighborhoodSelectContainer = () => {
  const dispatch = useDispatch();
  const { map } = useMap();
  const {t} = useTranslation();

  const { handleGeolocation } = useGeoLocation();
  const { handleCloseModalSelectNeighbor } = useModal();

  const cityNeighborhood = useSelector(state => state.map.zones);

  const handleSelectNeighbor = value => {
    const bounds = bbox(value);
    if (map && bounds && bounds.length > 0) {
      map.fitBounds(bounds);
      handleCloseModalSelectNeighbor();
      dispatch(setZonesOfCity([]));
    }
  };

  return (
    <>
      <h2 className="heading">{t('quarter.title')}</h2>
      <ul className="list-select h-40 has-buttons flow-half">
        {cityNeighborhood.map(elem => (
          <li key={elem.name}>
            <button onClick={() => handleSelectNeighbor(elem.bbox)}>
              {elem.label}
            </button>
          </li>
        ))}
      </ul>
      <SecondaryButtonWithIcon 
        icon='geoloc'
        label={t('button.geolocate_button')} 
        handleClick={handleGeolocation}
      />
      <ForwardButton 
        label={t('button.continue_button')}
        handleClick={handleCloseModalSelectNeighbor}
      />
    </>
  );
};